import React, { useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { useAsyncSetState } from "use-async-setstate";
import Formsy from "formsy-react";

import { debounce } from "../utils/index";
import TextField from "../bootstrap/input";
import { setFormData } from "../manager/form";
import { findBuildingQuery, getFindBuildingResult } from "../logic/address";

import MapMarkerAltIcon from "../../images/icons/map-marker-alt.svg";
import TimesWhiteImage from "../../images/icons/times-white.svg";
import { console } from "window-or-global";

import {client} from "../main";


export default function AddressAutoComplete(props) {
  const [unitNo, setUnitNo] = useAsyncSetState(null);
  const [addresses, setAddresses] = useAsyncSetState([]);
  const [selectedAddress, setSelectedAddress] = useAsyncSetState(null);
  const [addressError, setAddressError] = useAsyncSetState(false);
  const [unitError, setUnitError] = useAsyncSetState(null);

  const { highlight, home, init, inline, showLocator, setBuilding } = props;
  const rowClassName = `
    vw-address-locator 
    ${inline ? "inline" : ""} 
    ${highlight ? "highlight" : ""} 
    ${showLocator ? "show-address-locator" : "hide-address-locator"} 
    ${init ? "vw-hide" : ""} 
    magictime-300ms
  `;

  const handleValidSubmit = async () => {
    console.log({unitNo, selectedAddress, setBuilding})
    if (!unitNo) {
      return setUnitError(true);
    }

    if (!selectedAddress) {
      return setAddressError(true);
    }

    await setFormData({
      building: selectedAddress,
      unit: unitNo,
    });

    return setBuilding && setBuilding({...selectedAddress, unitNo});
  };

  const handleAddressChange = debounce(async (address) => {
    const response = await client.query({
      fetchPolicy: "no-cache",
      query: findBuildingQuery,
      variables: {address},
    });
    const result = getFindBuildingResult(response);
    console.log({response, result})

    if (!result.length) {
      console.log("here");
      return setAddressError(true);
    }

    await setAddressError(false);
    return setAddresses(result);
  }, 250);

  const handleAddressSelect = (value) => setSelectedAddress(value);

  return (
    <Formsy>
      <div className={rowClassName}>
        <Container fluid className="no-gutters">
          <Row>
            <Col className="vw-al-header">
              {"To get started, check your address"}
            </Col>
          </Row>
          <Row
            className={`${
              home ? "" : "justify-content-center"
            } flex-align-center no-gutters`}
          >
            <Col xs={12} md={9} lg={8} className="mb-1 mb-md-0">
              <div className={`vw-field ${home ? "highlight" : ""} vw-street`}>
                <div
                  className={`vw-placeholder ${
                    selectedAddress !== null ? "hasValue" : ""
                  }`}
                >
                  {"Street Address"}
                </div>
                {selectedAddress !== null ? (
                  <div
                    className="vw-al-selected-address-bg"
                    style={{ backgroundImage: `url(${MapMarkerAltIcon})` }}
                  >
                    <div
                      className="vw-al-selected-address-label"
                      onClick={() => setSelectedAddress(null)}
                      style={{ backgroundImage: `url(${TimesWhiteImage})` }}
                    >
                      {selectedAddress.name}
                    </div>
                  </div>
                ) : (
                  <input
                    name="address"
                    type="text"
                    onChange={async (e) =>
                      await handleAddressChange(e.target.value)
                    }
                    className={`vw-al-input-field ${
                      addressError ? "border-red" : ""
                    }`}
                  />
                )}
                {selectedAddress === null && addresses.length > 0 && (
                  <div className="vw-al-locations">
                    {addresses.map((address) => (
                      <div
                        key={`address-${address.id}`}
                        className="vw-al-location"
                        style={{ backgroundImage: `url(${MapMarkerAltIcon})` }}
                        onClick={() => handleAddressSelect(address)}
                      >
                        {address.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Col>
            <Col xs={12} md={3} lg={1} className="mb-1 mb-md-0">
              <TextField
                name="unitNo"
                className={`${
                  home ? "highlight" : ""
                }`}
                inputClass={`input-unit-no ${unitError ? "border-red" : ""}`}
                onChange={(e) => setUnitNo(e.target.value)}
                placeholder="Unit #"
              />
            </Col>
            <Col xs={12} lg={"auto"} className="mt-md-1 mt-lg-0 ml-lg-1">
              <div className="vw-field">
                <button
                  onClick={() => handleValidSubmit()}
                  className={`check-el-btn btn btn-orange w-100 w-md-unset`}
                >
                  {!home ? "Check Eligibility" : "Join us"}
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Formsy>
  );
}

// export default function AddressLocator(props) {
//   const [state, setState] = useState({
//     address: "",
//     showNotFound: false,
//   });

//   const handleACChange = debounce((value) => {
//     return setState({
//       ...state,
//       address: value,
//     });
//   }, 250);

//   async function handleItemSelect(address) {
//     return setState({
//       ...state,
//       selected: address,
//     });
//   }
//   async function handleOnClearSelection() {
//     return setState({
//       ...state,
//       selected: undefined,
//     });
//   }
//   async function handleShowNotFound() {
//     return setState({
//       ...state,
//       showNotFound: true,
//     });
//   }
//   async function handleRequestHideNotFound() {
//     return setState({
//       ...state,
//       showNotFound: false,
//     });
//   }

//   async function handleOnFocus() {
//     if(!state.location && props.showLocator) {
//       try {
//         const location = await getLocation();
//         if (location) {
//           await set({
//             location: {
//               lat: location.coords.latitude,
//               lng: location.coords.longitude,
//             },
//           });
//         }
//       } catch(err) {
//         console.log("err", err);
//       }
//     }
//   }

//   async function handleValidSubmit(data) {
//     // const {router} = this.context;
//     if(!state.selected) {
//       return;
//     }
//     const response = await this.props.refetch({address: this.state.selected.label});
//     if (response.data) {
//       if (response.data.findBuilding[0]) {
//         setFormData({buildingData: response.data.findBuilding[0]});
//         window.location = `/register/?building=${response.data.findBuilding[0].code}&unitno=${data.unitNo}`;
//         return undefined;
//       }
//     }
//     return this.handleShowNotFound();
//   }

//   return (
//     <div>

//     </div>
//   );

// }
